import { render, staticRenderFns } from "./QingTuanJob.vue?vue&type=template&id=c1925590&"
import script from "./QingTuanJob.vue?vue&type=script&lang=js&"
export * from "./QingTuanJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports